export default {"src":"/_next/static/media/home.5b88f6a8.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};